import {createFileRoute} from '@tanstack/react-router'
import MyCirclesView from "../../../players/MyCirclesView.tsx";

export const Route = createFileRoute('/_app/circles/')({
    component: RouteComponent,
    validateSearch: (search: Record<string, unknown>) => ({
        tab: (search.tab as string) || 'clubs',
    }),
})

function RouteComponent() {
    return <MyCirclesView />
}
